export const DEFAULT_GUESTS_HEADING = 'Attendees';
export const DEFAULT_GUESTS_DESCRIPTION = 'Complete the details for each attendee.';
export const DEFAULT_GUESTS_SAVE_BUTTON = 'Save attendee';

export type GuestSectionSettings = {
  heading?: string | null;
  description?: string | null;
  saveButton?: string | null;
};

/**
 * The heading and description above the guest rows, and the button that saves one. The heading or
 * description cleared on purpose shows none; a button always needs a label.
 */
export function guestSectionText(settings: GuestSectionSettings | null | undefined) {
  return {
    heading: (settings?.heading ?? DEFAULT_GUESTS_HEADING).trim(),
    description: (settings?.description ?? DEFAULT_GUESTS_DESCRIPTION).trim(),
    saveButton: settings?.saveButton?.trim() || DEFAULT_GUESTS_SAVE_BUTTON,
  };
}
